import styled from 'styled-components';

export const LoginInfoWrapper = styled.div`
  flex: 1 0 0;
  align-self: stretch;
  padding-top: 80px;
  padding-left: 8%;
`;

export const LoginTitleContainer = styled.div`
  display: flex;
  gap: 8px;
  font-size: 2.25rem;

  p {
    &:first-child {
      font-weight: 300;
    }

    &:last-child {
      font-weight: 600;
    }
  }
`;

export const BrandingContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

export const BrandingTextContainer = styled.div`
  max-width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 10%;

  p {
    margin-bottom: 12px;

    span {
      font-weight: 600;
    }

    &.title {
      font-size: 1.25rem;
      color: #318077;
      font-weight: 600;
      margin-bottom: 24px;
    }
  }
`;

export const BrandingImageContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8%;

  @media (min-height: 1050px) {
    padding-bottom: 16%;
  }
`;
